import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { v4 as uuidV4 } from 'uuid'

export type ToastItem = {
  id?: string
  message: string
  variant: string
  hide: boolean
  loginError?: boolean
  importUserError?: boolean
}

@Module({
  name: 'toast',
  stateFactory: true,
  namespaced: true,
})
export default class ToastModule extends VuexModule {
  public toastItems: ToastItem[] = []

  @Mutation
  public addToastItem(item: ToastItem): void {
    this.toastItems.push(item)
  }

  @Mutation
  public removeToastItem(id: string): void {
    this.toastItems = this.toastItems.filter((item) => item.id !== id)
  }

  @Mutation
  public hideToastItem(id: string): void {
    const item = this.toastItems.find((item) => item.id === id)
    if (item) item.hide = true
  }

  @Action({ rawError: true })
  async show(addItem: {
    message: string
    variant: string
    showMs: number
    loginError?: boolean
    importUserError?: boolean
  }): Promise<void> {
    const item = {
      id: uuidV4(),
      message: addItem.message,
      variant: addItem.variant,
      hide: false,
      loginError: addItem.loginError,
      importUserError: addItem.importUserError,
    }
    this.addToastItem(item)
    await new Promise(() => {
      // アニメーションのため
      setTimeout(() => {
        this.hideToastItem(item.id)
      }, addItem.showMs - 300)
      setTimeout(() => {
        this.removeToastItem(item.id)
      }, addItem.showMs)
    })
  }

  @Action({ rawError: true })
  success(message: string): void {
    this.show({ message, variant: 'success', showMs: 8000 })
  }

  @Action({ rawError: true })
  info(message: string): void {
    this.show({ message, variant: 'info', showMs: 8000 })
  }

  @Action({ rawError: true })
  error(payload: {
    message: string
    loginError?: boolean
    importUserError?: boolean
  }): void {
    const { message, loginError, importUserError } = payload
    this.show({
      message,
      variant: 'error',
      showMs: 8000,
      loginError,
      importUserError,
    })
  }
}
